"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/**Acomoda un conjunto de elementos en un <div /> con varios <div class="row" /> y <div class="col-md-x" /> que tendran a los elementos dados.
 * Los elementos nulos, undefined o false seran ignorados
 */
function autogrid(columnSize, elements) {
    //Quitar los elementos nulos y falsos
    elements = elements.filter(x => x);
    const maxColumns = 12;
    const columnsPerRow = Math.floor(maxColumns / columnSize);
    const rows = Math.ceil(elements.length / columnsPerRow);
    const ret = [];
    const columnClass = "col-md-" + columnSize;
    let index = 0;
    for (let row = 0; row < rows; row++) {
        const children = [];
        for (let column = 0; column < columnsPerRow; column++) {
            const currentColumn = React.createElement("div", { className: columnClass }, elements[index]);
            children.push(currentColumn);
            index++;
        }
        const currentRow = React.createElement("div", { className: "row" }, ...children);
        ret.push(currentRow);
    }
    return React.createElement("div", {}, ...ret);
}
exports.autogrid = autogrid;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/autogrid.js
// module id = 2199
// module chunks = 0